import React, {Component, ErrorInfo, ReactNode} from 'react'
import {withTranslation, WithTranslation} from 'react-i18next'
import styled from 'styled-components'
import ModalAtom from '../../to_layout/modal/modal.atom'
import SvgIconAtom from '../../to_content/svg_icon/svg_icon.atom'
import TypographyAtom from '../../to_content/typography/typography.atom'
import error_boundaryStyles from './error_boundary.styles'

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
}

const apAtomName = {ap_atom_name: 'apErrorBoundaryAtom'}

const StyledWrapper = styled(props => <div {...props} />)`
  ${error_boundaryStyles}
`

class ErrorBoundaryAtom extends Component<Props & WithTranslation, State> {
  constructor(props: Props & WithTranslation) {
    super(props)
    this.state = {
      hasError: false,
    }
  }

  public static getDerivedStateFromError(): State {
    // Update state so the next render will show the fallback UI.
    return {hasError: true}
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // eslint-disable-next-line
    console.error('Uncaught error:', error, errorInfo)
  }

  public render() {
    const {hasError} = this.state
    const {t, children} = this.props

    if (hasError) {
      return (
        <ModalAtom open>
          <StyledWrapper {...apAtomName}>
            <SvgIconAtom ap_type="errorBoundary" />
            <TypographyAtom ahd_type="h6">
              {t('errorBoundary.title')}
            </TypographyAtom>
            <TypographyAtom ahd_type="step">
              {t('errorBoundary.description')}
            </TypographyAtom>
          </StyledWrapper>
        </ModalAtom>
      )
    }

    return children
  }
}

export default withTranslation()(ErrorBoundaryAtom)
